import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { GameProvider } from './context/GameContext';
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import VerifyEmailPage from './components/VerifyEmailPage';
import CodeOfConductPage from './components/CodeOfConductPage';
import CharacterSelectPage from './components/CharacterSelectPage';
import CreateCharacterPage from './components/CreateCharacterPage';
import OpeningCinematic from './components/OpeningCinematic';
import GamePage from './components/GamePage';
import CharacterSheet from './components/CharacterSheet';
import AdminPanel from './components/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import ColorblindFilters from './components/ColorblindFilters';
import './App.css';
import './styles/Game.css';
import './styles/rarity.css';

function App() {
  return (
    <AuthProvider>
      <GameProvider>
        <Router>
          <div className="App">
            <ColorblindFilters />
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#2c4464',
                  color: '#ffffff',
                  border: '1px solid #839dbf'
                }
              }}
            />
            <Routes>
              <Route path="/login" element={<ErrorBoundary><LoginPage /></ErrorBoundary>} />
              <Route path="/register" element={<ErrorBoundary><RegisterPage /></ErrorBoundary>} />
              <Route path="/verify-email" element={<ErrorBoundary><VerifyEmailPage /></ErrorBoundary>} />
              <Route path="/code-of-conduct" element={<ErrorBoundary><CodeOfConductPage /></ErrorBoundary>} />
              <Route
                path="/characters"
                element={
                  <ProtectedRoute requireCharacter={false}>
                    <ErrorBoundary><CharacterSelectPage /></ErrorBoundary>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-character"
                element={
                  <ProtectedRoute requireCharacter={false}>
                    <ErrorBoundary><CreateCharacterPage /></ErrorBoundary>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/opening-cinematic"
                element={
                  <ProtectedRoute requireCharacter={false}>
                    <ErrorBoundary><OpeningCinematic /></ErrorBoundary>
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/game" 
                element={
                  <ProtectedRoute>
                    <ErrorBoundary>
                      <GamePage />
                    </ErrorBoundary>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/character" 
                element={
                  <ProtectedRoute>
                    <ErrorBoundary><CharacterSheet /></ErrorBoundary>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <ErrorBoundary><AdminPanel /></ErrorBoundary>
                  </ProtectedRoute>
                } 
              />
              <Route path="/" element={<ErrorBoundary><LandingPage /></ErrorBoundary>} />
            </Routes>
          </div>
        </Router>
      </GameProvider>
    </AuthProvider>
  );
}

export default App;
